import styled from 'styled-components';
import Dimens from 'utils/dimens';

export default styled.div`
  margin: ${Dimens.defaultSideSpacing} ${Dimens.defaultSideSpacing} auto;
`;
